import moment from "moment";

import { getGraphDataPointsInterval } from "utils/utils";
import ChartConstant from "constants/chartConstant";
import { PRIMARY_COLOR } from "constants/globalConstants";
import { getPlotlyIcons } from "constants/plotly.const";

import { parseChartData } from "pages/Chart/ChartHelper/ChartDataParser";

//const onPlotRefresh = () => {};
//const onDownloadPlot = () => {};
const onPlotZoom = () => {};
//Keeping commented code as it may required in future
// const getChartConfig = () => getPlotlyIcons(onDownloadPlot, onPlotRefresh, false);
const getChartConfig = () => getPlotlyIcons(null, null, false, false, false);
const handleClick = () => false;

export const parseTimeseriesData = (tag, plotData, xAxisRange, isModeBarVisible) => {
  const Type = ChartConstant.CHART_DEFAULT_PLOT_TYPE;
  const PLOT_FORMAT = ChartConstant.CHART_PLOT_FORMATS.SINGLE_PLOT;
  const tagsToShow = [{ ...tag, Type, Color: PRIMARY_COLOR }];
  const { Layout: layout, Data: data } = parseChartData(PLOT_FORMAT, tagsToShow, plotData, null, null, xAxisRange, null,null);
  layout.showlegend = false;
  layout.margin.b = isModeBarVisible ? 40 : 60;
  layout.margin.t = isModeBarVisible ? layout.margin.t : 20;
  layout.xaxis.fixedrange = true;
  layout.yaxis.fixedrange = true;
  const config = getChartConfig();
  config.displayModeBar = isModeBarVisible;
  return { data, layout, handleDoubleClick: handleClick, handleClick, config, onRelayout: onPlotZoom };
};

export const getTagDataPayload = params => {
  let { tagData, isDaySeries, isSmartInsight, endTime } = params;

  const tempDate = isSmartInsight
    ? moment(endTime).subtract(1, "days")
    : isDaySeries
    ? moment().subtract(1, "days")
    : moment().subtract(tagData.Duration?.split(" ")[0], "months");

  const startTime = tempDate.unix();
  endTime = (endTime ? moment(endTime) : moment()).unix();
  const group = getGraphDataPointsInterval({ startTime, endTime });

  return { tags: tagData.TagId, startTime, endTime, group };
};
